import type { ValueOf } from 'type-fest'
import type {
  ArtworkBaseFragment,
  GenerationModel,
} from '../services/apollo/generated/graphql'

/** From packages/pixai-server/src/service/helper/filter/taskFilter/PixaiKeywordFilter.ts */
export const PromptsModerationActions = {
  PASS: 'PASS',
  PASS_FEEDBACK: 'PASS_FEEDBACK',
  WARN_FEEDBACK: 'WARN_FEEDBACK',
  MEMBER_WARN_FEEDBACK: 'MEMBER_WARN_FEEDBACK',
  REJECT_SET_NSFW_GUIDANCE: 'REJECT_SET_NSFW_GUIDANCE',
  REJECT_FEEDBACK: 'REJECT_FEEDBACK',
}
export type PromptsModerationAction = ValueOf<typeof PromptsModerationActions>

export const SensitiveErors = {
  CHILD_PORN: 'CHILD_PORN',
  UNDERAGE_USER_SENSITIVE: 'UNDERAGE_USER_SENSITIVE',
  REALISTIC_MODEL_SENSITIVE: 'REALISTIC_MODEL_SENSITIVE',
}

// User Content Safety
/**
 * If Artwork/Model is considered "Sensitive Content"
 */
export function isUserContentSensitive(
  entity?: Pick<ArtworkBaseFragment, 'flag'> | GenerationModel,
): boolean {
  if (!entity) return false
  return (entity?.flag?.isSensitive || entity?.flag?.isMinors) ?? false
}

export function getContentSafetyLabelForUserContent(
  entity?: Pick<ArtworkBaseFragment, 'flag'> | GenerationModel,
) {
  const isSensitive = isUserContentSensitive(entity)

  if (isSensitive) return 'sensitive'
  return undefined
}

export function getContentSafetyScores(extra?: {
  textSafetyScore?: number
  mediaSafetyScore?: number
}): {
  textSafetyScore: string
  mediaSafetyScore: string
} {
  const textSafetyScore = extra?.textSafetyScore?.toString() ?? '?'
  const mediaSafetyScore = extra?.mediaSafetyScore?.toString() ?? '?'

  return {
    textSafetyScore,
    mediaSafetyScore,
  }
}

export function getGenerationModelArtworkSafetyScore(artworkSafetyScore?: {
  safetyScoreCount?: number
  safetyScoreSum?: number
}): string {
  const { safetyScoreCount, safetyScoreSum } = artworkSafetyScore ?? {}
  if (!safetyScoreCount || !safetyScoreSum || safetyScoreCount < 3) return '?'
  const safetyScore = safetyScoreSum / safetyScoreCount
  return safetyScore.toFixed(1)
}
